<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <!-- <v-flex xs12 v-if="active.length === 0">
        <v-card>
          <v-card-text>No Pending Appointment</v-card-text>
        </v-card>
      </v-flex>
      <v-flex v-for="app in active" :key="app.id" xs12 sm3 md2>
        <v-card>
          <v-card-text
            @click="$router.push(`/doctor/appointments/${app.id}`)"
            class="text-xs-center card-hover"
          >
            <div class="text-capitalize title font-weight-bold">{{app.patient.name}}</div>
            <div class="mt-2">{{app.date | moment('YYYY-MM-DD')}}</div>
            <div class="font-weight-bold mt-2">{{app.fee | currency('AFN')}}</div>
          </v-card-text>
        </v-card>
      </v-flex>-->
      <v-flex xs12>
        <div class="section-title di-flex align-center justify-space-between">
          <div>List of Appointments</div>
          <div style="width: 40%;">
            <v-text-field
             v-debounce:500ms="getAppointments"
              v-model="search"
              label="search"
              class="rounded"
              outline
              hide-details
              single-line
            ></v-text-field>
          </div>
        </div>
        <v-data-table
          :total-items="history.meta.total"
          :pagination.sync="pagination"
          :headers="headers"
          :items="history.data"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr class="hover" @click="$router.push(`/doctor/appointments/${props.item.id}`)">
              <td>{{ props.item.patient.name }}</td>
              <td>{{ props.item.date | moment('YYYY-MM-DD') }}</td>
              <td>{{ props.item.fee | currency('AFN') }}</td>
              <td class="text-capitalize" :class="props.item.status">{{ props.item.status }}</td>
              <td>
                <v-icon
                  v-if="props.item.status !== 'done'"
                  @click.stop="deleteAppointment(app)"
                >mdi-delete-outline</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  // layout: "single",
  middleware: "doctor",
  data() {
    return {
      search: "",
      active: [],
      history: {
        data: [],
        meta: {},
        links: {}
      },
      pagination: {descending:true},
      headers: [
        { text: "Patient Name", value: "updated_at" },
        { text: "Date", value: "date" },
        { text: "Fee", value: "fee" },
        { text: "Status", value: "status" },
        { text: "", value: "status", sortable:false}
      ]
    };
  },
  computed: {
    doctor() {
      return this.$store.getters["auth/user"];
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getAppointments();
      }
    }, 
  },
  methods: {
    getAppointments() {
      // const apps = this.axios.get("/api/appointments");
      // const history = this.axios.get("/api/appointments/history");

      // Promise.all([apps, history]).then(values => {
      //   this.active = values[0].data.data;
      //   this.history = values[1].data;
      // });

      const { sortBy, descending, page, rowsPerPage } = this.pagination;

      let query = `/api/appointments?doctor_id=${
        this.doctor.id
      }&rows_per_page=${rowsPerPage}&search=${encodeURIComponent(
        this.search
      )}&page=${page}`;

      if (sortBy) query = `${query}&sort_by=${sortBy}`;
      if (descending !== null) query = `${query}&desc=${descending ? 1 : 0}`;
      

      this.axios.get(query).then(result => {
        this.history = result.data;
      });
    },
    deleteAppointment(app) {
      this.$modal.show({
        message: `Are you sure, you want to delete this appointment?`,
        mode: "delete",
        onConfirm: async () => {
          await this.axios.delete(`/api/appointments/${app.id}`);
          this.getAppointments();
        }
      });
    }
  }
};
</script>